import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { LockIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-109">
      {/* Intense background glow for finale */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-glow/10 rounded-full blur-[150px] pointer-events-none" data-id="element-110" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="glass-card rounded-3xl p-8 md:p-16 text-center border-cyan-accent/40 shadow-[0_0_50px_rgba(0,229,255,0.15)]" data-id="element-112">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 leading-relaxed" data-id="element-113">
            Obtén acceso inmediato a "Prompt Engineering Real-Life" y domina la
            herramienta más potente de nuestra era por menos de lo que cuesta un
            almuerzo.
          </h2>

          <div className="my-12 relative inline-block" data-id="element-114">
            <div className="absolute inset-0 bg-cyan-glow/20 blur-2xl rounded-full" data-id="element-115" />
            <div className="relative" data-id="element-116">
              <span className="block text-cyan-accent font-semibold uppercase tracking-wider mb-2" data-id="element-117">
                Inversión única
              </span>
              <span className="block text-2xl md:text-3xl text-gray-500 font-bold line-through mb-2" data-id="element-118">
                $19.99 USD
              </span>
              <span className="text-6xl md:text-8xl font-black text-white text-glow tracking-tight" data-id="element-119">
                $6.99{' '}
                <span className="text-3xl md:text-4xl text-gray-400 font-bold" data-id="element-120">
                  USD
                </span>
              </span>
              <span className="block mt-3 inline-block bg-green-500/20 text-green-400 text-sm font-bold px-4 py-1.5 rounded-full border border-green-500/30 uppercase tracking-wider" data-id="element-121">
                65% de descuento
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center space-y-6" data-id="element-122">
            <CTAButton className="w-full sm:w-auto md:px-12 md:py-6 md:text-2xl" href="https://flexiofertas.com/cart/50714364838174:1" data-id="element-123">
              ¡Quiero Dominar la IA Ahora!
            </CTAButton>

            <div className="flex items-center justify-center text-gray-400 bg-navy-900/50 px-4 py-2 rounded-full border border-white/5" data-id="element-124">
              <LockIcon className="w-4 h-4 mr-2 text-green-400" data-id="element-125" />
              <span className="text-sm" data-id="element-126">
                Acceso instantáneo tras la compra. Pago 100% seguro.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}